export default __webpack_public_path__ + "static/media/placeholder_business03-jp-mobile.4f8696cb.png";